import React from "react"

import useTemplateStore from "../../data/templateStore"
import useOneGameStore from "../../data/oneGameStore"
import { BsFillBackspaceFill } from "react-icons/bs"

export default function CategoryList({
    currentRoundHasCategory,
    currentRoundCategory,
    currentRound,
    categories,
    gameRounds,
    setCategory,
    setScoringRound,
    setCurrentRound,
}) {
    const subCat = useTemplateStore(state => state.subCat)
    const game = useOneGameStore(state => state.game)

    // Get all teams and their scores
    const teams = game?.teams || []
    const teamScores = teams.map(team => {
        const totalScore = team.scores.reduce((acc, score) => {
            return acc + score.questions.filter(q => q.correct).length
        }, 0)
        return {
            team: team.team,
            displayName: team.displayName,
            score: totalScore
        }
    })

    // Get teams that have already picked categories
    const teamsThatPicked = game?.rounds
        ?.filter(round => round.round < currentRound)
        .map(round => round.team) || []

    // Sort teams by score (lowest first)
    const sortedTeams = [...teamScores].sort((a, b) => a.score - b.score)

    // Find the next team to pick
    let nextTeamToPick = null
    for (const team of sortedTeams) {
        // Count how many times this team has picked
        const timesPicked = teamsThatPicked.filter(t => t === team.team).length
        
        // Count how many times other teams have picked
        const otherTeamsPicked = teamsThatPicked.filter(t => t !== team.team).length
        
        // Team can pick if:
        // 1. They haven't picked yet, OR
        // 2. They've picked once but every other team has picked at least once
        if (timesPicked === 0 || (timesPicked === 1 && otherTeamsPicked >= teams.length - 1)) {
            nextTeamToPick = team
            break
        }
    }

    return (
        <ul className="live-scoring-list">
            {/* this should only show if the current round selected has a category */}
            {currentRoundHasCategory() && (
                <p>
                    <button onClick={() => setScoringRound(true)}>
                        Score Round {currentRound}
                    </button>
                </p>
            )}
            <li
                className="live-scoring-go-back"
                onClick={() => setCurrentRound(0)}
            >
                <BsFillBackspaceFill /> Go Back
            </li>
            {currentRoundHasCategory() && (
                <li
                    className="live-scoring-selected-category"
                    onClick={() => setCurrentRound(0)}
                >
                    {currentRoundCategory() || "Choose Category"}
                </li>
            )}
            {nextTeamToPick && (
                <li className="live-scoring-selected-team">
                    {nextTeamToPick.displayName || "Team " + nextTeamToPick.team} is picking
                </li>
            )}
            {categories
                .filter(cat => !gameRounds.find(r => r.category === cat.id))
                .filter(cat => cat.name !== "Pictures")
                .map(category => (
                    <li
                        key={category.id}
                        onClick={() => nextTeamToPick && setCategory(currentRound, category.id, nextTeamToPick.team)}
                        className={!nextTeamToPick ? "disabled" : ""}
                    >
                        {category.name}{" "}
                        {category.name === "Mystery" && `: ${subCat}`}
                    </li>
                ))}
            {categories
                .filter(cat => gameRounds.find(r => r.category === cat.id))
                .filter(cat => cat.name !== "Pictures")
                .map(category => (
                    <li
                        key={category.id}
                        onClick={() => nextTeamToPick && setCategory(currentRound, category.id, nextTeamToPick.team)}
                        className="live-scoring-not-available-category"
                    >
                        {category.name} - (Already Used)
                    </li>
                ))}
        </ul>
    )
}
